<mat-dialog-content class="mat-typography" style="max-width: 750px;">
  
    <h1 mat-dialog-title>Betroffene Positionen löschen?</h1>

    <p>
      Diese Aktion hat zur Folge, dass folgende Positionen aus der Tabelle gelöscht werden:
    </p>
    <ul>
        <li *ngFor="let affectedEntry of dialogData.affectedEntries">{{affectedEntry.product.name}}</li>
    </ul>
    <p>
      Sind sie sicher, dass sie die betroffenen Positionen aus Tabelle entfernen möchten?
    </p>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial (click)="cancel()">Nein</button>
  <button mat-button (click)="confirmDeletion()">Ja</button>
</mat-dialog-actions>
